module.exports = __webpack_public_path__ + "img/banner.b095dcef.jpg";